import { Module } from "../lib/modules";
import { StateManager } from "../lib/stateManager";
import { calculateGameRating, CategoryScores } from "../utils/rating";

interface ArticleState {}

interface DOMElements {
  articleContentContainer: HTMLDivElement;

  modal: HTMLDivElement;
  modalImage: HTMLDivElement;
  closeButton: HTMLButtonElement;
  modalContent: HTMLDivElement;
}

export const Article: Module<ArticleState> = () => {
  const state = new StateManager<ArticleState>({});

  let elements: DOMElements | null = null;

  const init = () => {
    const ratingElement = document.querySelector(".rating") as HTMLDivElement | null;
    if (ratingElement) {
      const scores: CategoryScores = {
        gameplay: parseInt(ratingElement.dataset["gameplay"] as string) / 10,
        graphics: parseInt(ratingElement.dataset["graphics"] as string) / 10,
        visualDesign: parseInt(ratingElement.dataset["visual_design"] as string) / 10,
        audio: parseInt(ratingElement.dataset["audio"] as string) / 10,
        music: parseInt(ratingElement.dataset["music"] as string) / 10,
        narrative: parseInt(ratingElement.dataset["narrative"] as string) / 10,
        optimization: parseInt(ratingElement.dataset["optimization"] as string) / 10,
        stability: parseInt(ratingElement.dataset["stability"] as string) / 10,
        trueToVision: parseInt(ratingElement.dataset["true_to_vision"] as string) / 10,
        innovation: parseInt(ratingElement.dataset["innovation"] as string) / 10,
        longevity: parseInt(ratingElement.dataset["longevity"] as string) / 10,
        multiplayer: parseInt(ratingElement.dataset["multiplayer"] as string) / 10,
        value: parseInt(ratingElement.dataset["value"] as string) / 10,
        scale: parseInt(ratingElement.dataset["scale"] as string) / 10
      };

      const ratingScoreElement = ratingElement.querySelector(".rating__score") as HTMLSpanElement;

      const overallRating = calculateGameRating(scores);
      ratingScoreElement.innerText = Number.isInteger(overallRating)
        ? overallRating.toString()
        : overallRating.toFixed(1);
    }

    elements = {
      articleContentContainer: document.querySelector(".article__content") as HTMLDivElement,

      modal: document.getElementById("image-modal") as HTMLDivElement,
      modalImage: document.getElementById("modal-image") as HTMLDivElement,
      modalContent: document.getElementById("modal-content") as HTMLDivElement,
      closeButton: document.getElementById("modal-close-button") as HTMLButtonElement
    };

    if (!elements) {
      console.error("Required modal elements not found");
      return;
    }

    document.querySelectorAll("img").forEach((img) => {
      if (!elements) return;
      if (img.classList.contains("no-popup")) return;
      if (!elements.articleContentContainer.contains(img)) return;
      img.addEventListener("click", handlePopupClick(img));
    });

    // Add close modal events
    elements.closeButton.addEventListener("click", () => closeModal());

    // Close modal when clicking outside the image
    elements.modal.addEventListener("click", (e) => {
      if (!elements) return;
      if (e.target === elements.modal || e.target === elements.modalContent) {
        closeModal();
      }
    });
  };

  const closeModal = () => {
    if (!elements) return;

    // Allow background scrolling again
    document.body.style.overflow = "auto";

    // Wait for fade-out animation to complete before hiding
    elements.modal.style.display = "none";
  };

  const handlePopupClick = (img: HTMLImageElement): ((e: Event) => void) => {
    return (_e: Event) => {
      if (!elements) return;

      // Get the original image source (potentially higher quality)
      const imgSrc = img.getAttribute("src");
      const imgAlt = img.getAttribute("alt") || "";

      // Set modal image properties
      elements.modalImage.setAttribute("src", imgSrc || "");
      elements.modalImage.setAttribute("alt", imgAlt);

      // Display modal with fade-in effect
      elements.modal.style.display = "block";
      elements.modal.classList.add("fade-in");

      // Prevent scrolling of the background
      document.body.style.overflow = "hidden";
    };
  };

  const attachEventListeners = () => {};

  const detachEventListeners = () => {};

  const destroy = () => {
    detachEventListeners();
  };

  return {
    init,
    attachEventListeners,
    detachEventListeners,
    destroy,
    state: state,
    pages: ["/article/*"],
    name: "article"
  };
};
